/* 
 * Copyright (C) Patient10x (https://www.patient10x.com) - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */
import { AsyncAction, failed, loading, success } from "common/utils";
import { GetWidgetViewStatsBaseReportState } from "widget/widget.store";


export function GetWidgetViewStatsBaseReport(): AsyncAction {
  return async (dispatch, _getState, api) => {
    dispatch(GetWidgetViewStatsBaseReportState(loading()));
    try {
      const { value } = await api.get('/widgets/view-stats/base-report');
      dispatch(GetWidgetViewStatsBaseReportState(success(value)));
    } catch (error) {
      dispatch(GetWidgetViewStatsBaseReportState(failed(error)));
    }
  };
}